module.exports = __webpack_public_path__ + "img/38971-022.6271cbd4.jpg";